import { ExpandMore, Language } from '@coconut-software/ui/dist/icons';
import clsx from 'clsx';
import type { FC } from 'react';
import React, { useContext } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { LOCALE_NAMES } from '../../shared/constants';
import { LocaleContext } from '../contexts/LocaleContext';
import { SettingsContext } from '../contexts/SettingsContext';
import {
  EnhancedKioskLanguageRadioGroup,
  Orders,
} from './EnhancedKioskLanguageRadioGroup';

const useStyles = createUseStyles((theme: any) => ({
  expandButton: {
    background: 'var(--color-primary-main)',
    '& svg': {
      width: '1.5rem',
      height: '1.5rem',
    },
    '&:focus': {
      boxShadow: `inset 0 0 0 2px ${theme.palette.contrastText}`,
    },
    '&:active': {
      backgroundColor: 'var(--color-primary-darker)',
    },
  },
}));

interface EnhancedKioskLanguagePickerProps {
  maxLength?: number;
  onOpen: () => void;
}

const EnhancedKioskLanguagePicker: FC<EnhancedKioskLanguagePickerProps> = ({
  maxLength = 2,
  onOpen,
}) => {
  const classes = useStyles({ theme: useTheme() });
  const { availableLanguages } = useContext(SettingsContext);
  const [locale] = useContext(LocaleContext);

  if (!availableLanguages || availableLanguages.length <= 1) {
    return null;
  }

  return availableLanguages.length <= maxLength ? (
    <EnhancedKioskLanguageRadioGroup order={Orders.Row} />
  ) : (
    <button
      className={clsx(
        'flex flex-row text-xl sm:text-2xl font-semibold px-4 py-4 gap-x-2 rounded-full focus:outline-none',
        classes.expandButton,
      )}
      onClick={onOpen}
      type="button"
    >
      <Language />
      {LOCALE_NAMES[locale]}
      <ExpandMore />
    </button>
  );
};

export { EnhancedKioskLanguagePicker };
